const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  userId: state => state.user.userId,
  userInfo: state => state.user.userInfo,
  accessMenu: state => state.user.accessMenu,
  showAIGC: state => state.user.accessMenu ? state.user.accessMenu.indexOf('AIGC') > -1 : false,
  showOCPC: state => state.user.accessMenu ? state.user.accessMenu.indexOf('OCPC') > -1 : false,
  showCRM: state => state.user.accessMenu ? state.user.accessMenu.indexOf('CRM') > -1 : false,
  showOSINT: state => state.user.accessMenu ? state.user.accessMenu.indexOf('OSINT') > -1 : false,
  showCC: state => state.user.accessMenu ? state.user.accessMenu.indexOf('CC') > -1 : false,
  showSMS: state => state.user.accessMenu ? state.user.accessMenu.indexOf('SMS') > -1 : false,
  crmAdmin: state => state.user.crmRole && state.user.crmRole == '管理员',
  ocpcCustomer: state => state.user.usrIdentity ? state.user.usrIdentity.indexOf('1') > -1 : false,
  ocpcSupplier: state => state.user.usrIdentity ? state.user.usrIdentity.indexOf('2') > -1 : false,
  ocpcGetPhoneUp: state => state.user.usrIdentity ? state.user.usrIdentity.indexOf('3') > -1 : false,
  ocpcTaxBill: state => state.user.usrIdentity ? state.user.usrIdentity.indexOf('4') > -1 : false,
  apiCompanyId: state => state.user.apiCompanyId > 0 ? true : false,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js